export default __webpack_public_path__ + "static/vlad-f6a3ec6477304ffa16bf6786d0c988f3.png";